// actions.js
import * as types from "./../types/types";

export const resetStore = () => ({
  type: types.RESET_STORE,
});